import { useEffect, useState } from "react";
import Pageheader from "../common/Pageheader";
import {
  Avatar,
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery
} from "@mui/material";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";
import { GET_USER_CONTACTS, SAVECONTACTEVENT } from "../../constant/Apipath.jsx";
import { Getrequestcall } from "../../request/Getrequest.jsx";
import CloseIcon from "@mui/icons-material/Close";
import PromptModal from "../common/PromptModal";
import { Postrequestcall } from "../../request/Postrequest.jsx";
import { useNavigate } from "react-router-dom";
import PictureViewer from "../../common/PictureViewer.jsx";
import Loader from "../../common/Loader.jsx";
import AddContact from "../common/AddContact";
import { Search as SearchIcon } from "@mui/icons-material";
import { BIWhite } from "../../assets/helpers.jsx";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import theme from "../../theme/theme.js";
import { English } from "../../constant/EnglishFallback.jsx";
import AdContainer from "../common/AdContainer.jsx";
import { createChatGroupAndNavigate } from "../../common/Helper.jsx";

const BuilderNetwork = () => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.BuilderNetwork || {};
  const {
    TEXT_HEADER = English.BuilderNetwork.TEXT_HEADER,
    TEXT_SEARCH_MY_CONTACTS = English.BuilderNetwork.TEXT_SEARCH_MY_CONTACTS,
    TEXT_LOOK_FOR_PEOPLE = English.BuilderNetwork.TEXT_LOOK_FOR_PEOPLE,
    TEXT_NO_DATA = English.BuilderNetwork.TEXT_NO_DATA,
    TEXT_ME = English.BuilderNetwork.TEXT_ME,
    TEXT_SEND_MESSAGE = English.BuilderNetwork.TEXT_SEND_MESSAGE,
    TEXT_DELETE_CONTACT = English.BuilderNetwork.TEXT_DELETE_CONTACT,
    TEXT_DELETE = English.BuilderNetwork.TEXT_DELETE,
    TEXT_DELETE_CONTACT_CONF_TITLE = English.BuilderNetwork.TEXT_DELETE_CONTACT_CONF_TITLE,
    TEXT_DESC_CONFIRMATION = English.BuilderNetwork.TEXT_DESC_CONFIRMATION
  } = LanguageData || {};

  const [searchString, setSearchString] = useState("");
  const [loading, setLoading] = useState(false);
  const [allContacts, setAllContacts] = useState([]);
  const [newAllContacts, setNewAllContacts] = useState([]);
  const [filterContacts, setFilterContacts] = useState([]);
  const { loginData } = useSelector((state) => state?.main);
  const [newContactModalOpen, setNewContactModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [selectContact, setSelectcontact] = useState(null);
  const navigate = useNavigate();
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [shouldCall, setShouldCall] = useState(false);

  const getContacts = useCallback(async () => {
    setLoading(true);
    try {
      const currentUserObj = {
        firstName: loginData?.userInformation?.FirstName,
        lastName: loginData?.userInformation?.LastName,
        id: loginData?.userInformation?.UserId,
        pictureUrl: loginData?.pictureUrl,
        tradeName: loginData?.userInformation?.TradeName
      };
      // if (getResponse?.status === 200) {
      let getResponseContacts = await Getrequestcall(
        `${GET_USER_CONTACTS}/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      if (getResponseContacts?.status === 200) {
        const combinedArray = [currentUserObj, ...getResponseContacts?.data?.data];
        setAllContacts(combinedArray);
        setNewAllContacts(combinedArray);
        const filterNewItems = combinedArray.filter(
          (contact) => contact?.id !== loginData?.userInformation?.UserId
        );
        setFilterContacts(filterNewItems);
      }
      // }
    } catch (error) {
      console.log("getContacts -> Error When Getting Contacts ", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getContacts();
  }, [getContacts]);

  useEffect(() => {
    const handleRefresh = () => {
      getContacts();
    };
    window.addEventListener("REFRESH_BUILDER_NETWORK", handleRefresh);
    return () => {
      window.removeEventListener("REFRESH_BUILDER_NETWORK", handleRefresh);
    };
  }, [getContacts]);

  const handleSearchContact = (event) => {
    let inputValue = event.target.value;
    const cleanedValue = (inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, ""));
    if (cleanedValue !== "") {
      const newFilterContacts = filterContacts.filter((contact) =>
        contact.contactName.toLowerCase().includes(cleanedValue.toLowerCase())
      );
      setAllContacts(newFilterContacts);
      setSearchString(cleanedValue);
    } else {
      setAllContacts(newAllContacts);
      setSearchString("");
    }
  };

  const handleClear = () => {
    setAllContacts(newAllContacts);
    setSearchString("");
  };

  const handleDeleteContact = async () => {
    try {
      const getObject = {
        Id: 0,
        UserId: loginData?.userInformation?.UserId,
        ContactEmail: selectContact?.contactEmail,
        EventStatusId: 5, // eventStatusId 5 = delete
        ModifiedBy: loginData?.userInformation?.UserId
      };
      let getResponse = await Postrequestcall(SAVECONTACTEVENT, getObject, loginData?.accessToken);
      if (getResponse?.status === 201) {
        setDeleteConfirmModalOpen(false);
        getContacts();
      }
    } catch (error) {
      console.log("handleDeleteContact -> Error When Deleting Contact ", error);
    }
  };
  const navigateTochat = async (e, userId) => {
    e.preventDefault();
    createChatGroupAndNavigate(userId, loginData, dispatch, navigate);
  };

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Pageheader headerName={TEXT_HEADER} />
      <Card className="main-content-card">
        {loading ? (
          <Loader />
        ) : (
          <>
            <Grid sx={{ pb: 1.5,  display: "flex", alignItems: "center",  justifyContent: "space-between" }}  container spacing={2}>
              <Grid size={{ xs: 7, sm: 6, md: 4, lg: 4 }}>
                <Stack sx={{ backgroundColor: BIWhite, borderRadius: "5px" }}>
                  <TextField
                    variant="outlined"
                    placeholder={TEXT_SEARCH_MY_CONTACTS}
                    size="small"
                    value={searchString}
                    autoComplete="off"
                    onChange={(e) => handleSearchContact(e)}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment:
                          searchString !== "" ? (
                            <InputAdornment position="end">
                              <IconButton onClick={() => handleClear()}>
                                <CloseIcon />
                              </IconButton>
                            </InputAdornment>
                          ) : null
                      }
                    }}
                  />
                </Stack>
              </Grid>
              <Grid sx={{ display: "flex", justifyContent: "flex-end" }} height={"100%"} size={{ xs: 5, sm: 4, md: 3, lg: 2 }}>
                <Button variant="contained" onClick={() => setNewContactModalOpen(true)}>
                  {TEXT_LOOK_FOR_PEOPLE}
                </Button>
              </Grid>
            </Grid>

            <Box className="main-content-card-list">
              {allContacts.length !== 0 ? (
                <List disablePadding>
                  <Stack sx={{ gap: 1 }} >
                    {allContacts.map((contact, index) => {
                      return (
                        <Card
                          key={index.toString()}
                          className="pagelist-content"
                          sx={{ marginTop: "0px" }}>
                          <ListItem sx={{ m: 0, alignItems: "center" }} key={index.toString()} secondaryAction={ contact?.id !== loginData?.userInformation?.UserId && ( <Stack direction={"row"}>
                                  <Tooltip title={TEXT_SEND_MESSAGE}>
                                    <IconButton
                                      color="primary"
                                      size="small"
                                      onClick={(e) =>
                                        navigateTochat(e, Number(contact?.contactId))
                                      }>
                                      <QuestionAnswerIcon />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title={TEXT_DELETE_CONTACT}>
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() => {
                                        setSelectcontact(contact);
                                        setDeleteConfirmModalOpen(true);
                                      }}>
                                      <DeleteIcon />
                                    </IconButton>
                                  </Tooltip>
                                </Stack>
                              )
                            }
                            disablePadding>
                            <ListItemButton
                              sx={{
                                display: "flex",
                                flexDirection: "row"
                              }}
                              onClick={() => {
                                contact?.id === loginData?.userInformation?.UserId
                                  ? navigate(`/${contact?.id}`)
                                  : navigate(`/contacts/${contact?.contactId}`);
                              }}>
                              <ListItemAvatar>
                                <Avatar
                                  alt="contact-PictureUrl"
                                  src={
                                    contact?.id === loginData?.userInformation?.UserId
                                      ? contact?.pictureUrl
                                      : contact?.contactPictureUrl
                                  }
                                  onClick={() => {
                                    setSelectcontact(contact);
                                    setPictureViewerOpen(true);
                                  }}
                                />
                              </ListItemAvatar>
                              <ListItemText
                                primary={
                                  <Stack>
                                    {contact?.id !== loginData?.userInformation?.UserId ? (
                                      <Typography
                                        variant="body1"
                                        maxWidth={isSmallScreen ? "150px" : "300px"}
                                        noWrap>
                                        {contact?.contactName}
                                      </Typography>
                                    ) : (
                                      <Typography
                                        variant="body1"
                                        maxWidth={"300px"}
                                        noWrap
                                        component="div">
                                        {contact?.firstName + " " + contact?.lastName}
                                        <Typography
                                          variant="body1"
                                          component="span"
                                          sx={{
                                            color: "text.secondary",
                                            display: "inline"
                                          }}>
                                          {" "}
                                          {`(${TEXT_ME})`}
                                        </Typography>
                                      </Typography>
                                    )}
                                  </Stack>
                                }
                                secondary={contact?.tradeName}
                              />
                            </ListItemButton>
                          </ListItem>
                        </Card>
                      );
                    })}
                  </Stack>
                </List>
              ) : (
                <Box className="empty-data-card">
                  <Typography variant="h4">{TEXT_NO_DATA}</Typography>
                </Box>
              )}
            </Box>
          </>
        )}
        <AdContainer />
      </Card>
      <PictureViewer
        isOpen={pictureViewerOpen}
        onClose={() => setPictureViewerOpen(false)}
        src={
          selectContact?.id === loginData?.userInformation?.UserId
            ? selectContact?.pictureUrl
            : selectContact?.contactPictureUrl
        }
      />
      <PromptModal
        isOpen={deleteConfirmModalOpen}
        onClose={() => setDeleteConfirmModalOpen(false)}
        title={TEXT_DELETE_CONTACT_CONF_TITLE}
        desc={TEXT_DESC_CONFIRMATION}
        redButtonText={TEXT_DELETE}
        onRedButtonClick={() => handleDeleteContact()}
      />

      <AddContact
        isOpen={newContactModalOpen}
        onClose={() => {
          if (shouldCall === true) {
            setShouldCall(false);
            getContacts();
          }
          setNewContactModalOpen(false);
        }}
        setNewContactModalOpen={setNewContactModalOpen}
        from={"Profile"}
        setShouldCall={setShouldCall}
      />
    </Box>
  );
};
export default BuilderNetwork;

